export default "__VITE_ASSET__CrcJU3MX__"